import Vue from 'vue'

const state = {
    // 
}

const getters = {
    // 
}

const actions = {
    surveyRequest: async ({commit}, queries) => {
        let url = `/api/surveys/${queries.id}`;

        if (queries.with) {
            let params = '?'
            queries.with.forEach((w, i) => params += (i > 0 ? '&' : '')+'with['+i+']='+w)
            url += params
        }

        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    surveySessionCreateRequest: async ({commit}, queries) => {
        let url = `/api/survey_sessions`;

        return new Promise((resolve, reject) => {
            Vue.axios.post(url, queries)
                .then(result => {
                    resolve(result.data.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
    surveyByRefRequest: async ({commit}, queries) => {
        let url = `/api/surveys/ref/${queries.ref}`;

        if (queries.with) {
            let params = '?'
            queries.with.forEach((w, i) => params += (i > 0 ? '&' : '')+'with['+i+']='+w)
            url += params
        }

        return new Promise((resolve, reject) => {
            Vue.axios.get(url)
                .then(result => {
                    resolve(result.data)
                })
                .catch(err => {
                    if (err.response.status == 403)
                        commit('setSnack', {'type': 'red', 'msg': 'Action non autorisée'})
                    reject(err)
                })
        })
    },
}

const mutations = {
    // 
}

export default {
    state,
    getters,
    actions,
    mutations,
}